import { Sprite } from "@pixi/sprite";
import { Text } from "@pixi/text";
Text.prototype._renderCanvas = function(renderer) {
  this._autoResolution && this._resolution !== renderer.resolution && (this._resolution = renderer.resolution, this.dirty = !0), this.updateText(!0), Sprite.prototype._renderCanvas.call(this, renderer);
};
//# sourceMappingURL=Text.mjs.map
